/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './NavigationItem.scss'
import React from 'react'
import { Link } from 'react-router-dom'

function NavigationItem(props) {
  return (
    <li className={`NavigationItem`}>
      <Link to={props.to}>
        <div className="NavigationItem__Row">
          <span className="NavigationItem__Icon">{props.children}</span>
          <span className="NavigationItem__Label">{props.label}</span>
        </div>
      </Link>
    </li>
  )
}

export default NavigationItem
